import * as yup from '@if/core/yup'
import { ControlledAutocomplete, ControlledSelect } from '@if/mui'
import { Box, Chip, MenuItem, Stack, Typography } from '@mui/material'
import { EMerchantReportFrequency } from '@src/data/types/Constants'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export const MerchantReportFormSchema = yup.object().shape({
  reportGenerationFrequency: yup
    .string()
    .nullable()
    .oneOf(['', ...Object.values(EMerchantReportFrequency)])
    .default(EMerchantReportFrequency.never),
  reportRecipientsEmailList: yup.array().of(yup.string().email().required()).default([]),
})

const MerchantReportConfigPanel = () => {
  const { t } = useTranslation()
  const { control } = useFormContext<yup.InferType<typeof MerchantReportFormSchema>>()

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        {t('merchant.reports.configureReport')}
      </Typography>
      <Stack gap={1}>
        <ControlledSelect
          name="reportGenerationFrequency"
          control={control}
          label={t('merchant.reports.frequency')}
          emptyOptionLabel={t('common.eMerchantReportFrequency.never')}
          emptyOptionValue={EMerchantReportFrequency.never}
          fullWidth
        >
          <MenuItem value={EMerchantReportFrequency.daily}>{t('common.eMerchantReportFrequency.daily')}</MenuItem>
          <MenuItem value={EMerchantReportFrequency.weekly}>{t('common.eMerchantReportFrequency.weekly')}</MenuItem>
          <MenuItem value={EMerchantReportFrequency.monthly}>{t('common.eMerchantReportFrequency.monthly')}</MenuItem>
        </ControlledSelect>
        <ControlledAutocomplete
          name="reportRecipientsEmailList"
          control={control}
          label={t('merchant.reports.recipients')}
          multiple
          freeSolo
          autoSelect
          options={[]}
          renderValue={(tagValue, getTagsProps) =>
            tagValue.map((option, index) => (
              <Chip {...getTagsProps({ index })} key={option as string} label={option as string} />
            ))
          }
        />
      </Stack>
    </Box>
  )
}
export default MerchantReportConfigPanel
